<h1>Attachment</h1>

<br>

<div class="attachment-container">

  <mat-form-field>
    <input
      matInput
      [readonly]="reviewer"
      placeholder="Attachment Number"
      name="attachmentNum"
      value={{currentAttachment.attachmentNum}}
    >
  </mat-form-field>

  <mat-form-field>
    <input
      matInput
      [readonly]="reviewer"
      placeholder="DOP Number"
      name="dopNum"
      value={{currentAttachment.attachmentNum}}
    >
  </mat-form-field>

  <mat-form-field>
    <input
      matInput
      [readonly]="reviewer"
      placeholder="Attachment Type"
      name="attachmentType"
      value={{currentAttachment.attachmentType}}
    >
  </mat-form-field>

  <mat-form-field>
    <input
      matInput
      [readonly]="reviewer"
      placeholder="Link to File"
      name="linkToFile"
      value={{currentAttachment.linkToFile}}
    >
  </mat-form-field>

  <mat-form-field>
    <input
      matInput
      [readonly]="reviewer"
      placeholder="Name"
      name="name"
      value={{currentAttachment.name}}
    >
  </mat-form-field>

  <mat-form-field>
    <input
      matInput
      [readonly]="reviewer"
      placeholder="Description"
      name="description"
      value={{currentAttachment.description}}
    >
  </mat-form-field>

  <mat-form-field>
    <input
      matInput
      [readonly]="reviewer"
      placeholder="Timestamp"
      name="timeStamp"
      value={{currentAttachment.timeStamp}}
    >
  </mat-form-field>

</div>
